import {ref} from 'vue';

export default {
    install: (app, options) => {
        const invoices = ref([]);

        const loadInvoices = (url = '/dashboard/subscription-and-billing') => {
            window.lazy_axios.get(url)
                .then((response) => {
                    invoices.value = response.data.invoices.data;
                });
        };

        app.provide('invoices', invoices);
        app.provide('loadInvoices', loadInvoices);
    },
}
